import { defaultStore } from '../config'
import { stores } from '../../translations'

export const isAlfaGameActive = (store = defaultStore) => {
  const startDate = new Date('2026-05-20T12:00:00')
  const endDate = new Date('2026-07-31T23:59:59')
  const now = new Date()
  const isAlfaGameActive = now >= startDate && now <= endDate

  return isAlfaGameActive && store === stores.ru
}
